<z-select
    id="{{ id() }}"
    [options]="options()"
    [optionLabel]="optionLabel()"
    [optionValue]="optionValue()"
    [placeholder]="placeholder()"
    [disabled]="disabled ?? false"
    [class]="class"
    [label]="showLabel() == true ? label() : ''"
    [class]="class"
    [filter]="false"
    [showClear]="false"
    [filterBy]="'Name'"
    [(ngModel)]="model"
    (ngModelChange)="modelChange($event)"
    [ngModelOptions]="{ standalone: true }"
/>
